export default {
  eula: 'End User License Agreement',
  serviceTerms: 'Service Terms',
};
